import { environment } from 'src/environments/environment';

export const USER_APIS_ENDPOINTS = {
  DELETE_ACCOUNT: `${environment.BACKEND_URL}api/v2/users/deactivate`,
  GET_PROFILE_URL: `${environment.BACKEND_URL}api/user/viewOwnProfile`,
};
